import SearchWordDetailContainer from './SearchWordDetailContainer';
export default SearchWordDetailContainer;
